import type { DocumentSignature } from "@models";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import "./TiptapEditor.css";

const SignatureDataTable = <Row extends object>({
  ariaLabel,
  columns,
  rows,
}: {
  ariaLabel: string;
  columns: Array<{ key: keyof Row; label: string }>;
  rows: Row[];
}) => (
  <TableContainer className="tiptap-signature-table-scroll">
    <Table size="small" aria-label={ariaLabel}>
      <TableHead>
        <TableRow>
          {columns.map((column) => (
            <TableCell key={String(column.key)}>{column.label}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {columns.map((column) => (
              <TableCell key={String(column.key)}>
                {String(row[column.key])}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export const TiptapSignatureTable = ({
  signatureTable,
}: {
  signatureTable: DocumentSignature;
}) => (
  <section className="tiptap-signature-tables flex flex-col gap-3">
    <Typography variant="body1" className="pb-1" fontWeight="bold">
      Document Signature Table
    </Typography>
    <SignatureDataTable
      ariaLabel="Document signature table"
      columns={signatureTable.signatureColumns}
      rows={signatureTable.signatureRows}
    />

    <Typography variant="body1" className="pb-1 pt-2" fontWeight="bold">
      Revision History
    </Typography>
    <SignatureDataTable
      ariaLabel="Revision history"
      columns={signatureTable.revisionHistoryColumns}
      rows={signatureTable.revisionHistoryRows}
    />
  </section>
);

export default TiptapSignatureTable;
